import { GeocodingFeature } from '../../types/mapbox-search-api-v1.types';

interface SearchParams {
  query: string;
  proximity?: number[];
}

interface SearchState {
  latestSearch: {
    params: SearchParams | null;
    features: GeocodingFeature[] | null;
  };
}

const initialState: SearchState = {
  latestSearch: {
    params: null, // { query: string, proximity: [number, number] },
    features: null,
  },
};

const Actions = {
  SUGGESTIONS_CHANGED: 'search/suggestions-changed',
  FOCUSED_CHANGED: 'search/focused-changed',
};

const suggestionsChanged = ({
  params,
  features,
}: {
  params: SearchParams;
  features: GeocodingFeature[] | null;
}) => ({
  type: Actions.SUGGESTIONS_CHANGED,
  params,
  features,
});

const focusedChanged = (focused) => ({
  type: Actions.FOCUSED_CHANGED,
  focused,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SUGGESTIONS_CHANGED:
      return {
        ...state,
        latestSearch: {
          params: action.params,
          features: action.features,
        },
      };
    case Actions.FOCUSED_CHANGED:
      return {
        ...state,
        focused: action.focused,
      };
  }
  return state;
}

function selectSuggestedFeatures(state: { search: SearchState }) {
  return state.search.latestSearch.features;
}

function selectSearchParams(state: { search: SearchState }) {
  return state.search.latestSearch.params ?? { query: '' };
}

function selectFocused(state) {
  return state.search.focused;
}

export {
  reducer,
  suggestionsChanged,
  focusedChanged,
  selectSuggestedFeatures,
  selectSearchParams,
  selectFocused,
};
